<span class="marking pointee-colored-circle" [ngClass]="markingClass"></span>
